 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDTLU_1 from '@/components/Backed/tlu_1'
 import XHTMLENDMATTER06 from '@/components/xhtml/endmatter06'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLFRANTMATTER from '@/components/xhtml/frantmatter'
 import XHTMLCHAPTER01 from '@/components/xhtml/chapter01'
 import XHTMLCHAPTER02 from '@/components/xhtml/chapter02'
 import XHTMLCHAPTER03 from '@/components/xhtml/chapter03'
 import XHTMLCHAPTER04 from '@/components/xhtml/chapter04'
 import XHTMLCHAPTER05 from '@/components/xhtml/chapter05'
 import XHTMLCHAPTER06 from '@/components/xhtml/chapter06'
 import XHTMLCHAPTER07 from '@/components/xhtml/chapter07'
 import XHTMLCHAPTER08 from '@/components/xhtml/chapter08'
 import XHTMLCHAPTER09 from '@/components/xhtml/chapter09'
 import XHTMLCHAPTER10 from '@/components/xhtml/chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/chapter12'
 import XHTMLCHAPTER13 from '@/components/xhtml/chapter13'
 import XHTMLCHAPTER14 from '@/components/xhtml/chapter14'
 import XHTMLCHAPTER15 from '@/components/xhtml/chapter15'
 import XHTMLCHAPTER16 from '@/components/xhtml/chapter16'
 import XHTMLCHAPTER17 from '@/components/xhtml/chapter17'
 import XHTMLCHAPTER18 from '@/components/xhtml/chapter18'
 import XHTMLCHAPTER19 from '@/components/xhtml/chapter19'
 import XHTMLCHAPTER20 from '@/components/xhtml/chapter20'
 import XHTMLCHAPTER21 from '@/components/xhtml/chapter21'
 import XHTMLCHAPTER22 from '@/components/xhtml/chapter22'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLENDMATTER01 from '@/components/xhtml/endmatter01'
 import XHTMLENDMATTER02 from '@/components/xhtml/endmatter02'
 import XHTMLENDMATTER03 from '@/components/xhtml/endmatter03'
 import XHTMLENDMATTER04 from '@/components/xhtml/endmatter04'
 import XHTMLENDMATTER05 from '@/components/xhtml/endmatter05'
 import XHTMLENDMATTER07 from '@/components/xhtml/endmatter07'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/Backed/birdsfront_1",
 			"name" : "Backed/birdsfront_1",
 			"component" : BACKEDBIRDSFRONT_1
 		},
 		{
 			"path" : "/Backed/tlu_1",
 			"name" : "Backed/tlu_1",
 			"component" : BACKEDTLU_1
 		},
 		{
 			"path" : "/xhtml/endmatter06",
 			"name" : "xhtml/endmatter06",
 			"component" : XHTMLENDMATTER06
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/frantmatter",
 			"name" : "xhtml/frantmatter",
 			"component" : XHTMLFRANTMATTER
 		},
 		{
 			"path" : "/xhtml/chapter01",
 			"name" : "xhtml/chapter01",
 			"component" : XHTMLCHAPTER01
 		},
 		{
 			"path" : "/xhtml/chapter02",
 			"name" : "xhtml/chapter02",
 			"component" : XHTMLCHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js